export default __webpack_public_path__ + "static/media/CalculateBorrowingBase.ca5a3036.svg";